import styled from 'styled-components';

import { colors } from 'styles/colors';

const LinkIcon = styled.a`
   font-size: 14px;
   font-weight: 600;
   padding: 0.4rem 1rem;
   background: ${colors.primary};
   border: none;
   color: ${colors.white};
   border-radius: 20px;
   text-decoration: none;
   transition: transform 0.35s ease-in-out;
   letter-spacing: -0.02em;
   display: flex;
   align-items: center;
   &:hover {
      color: ${colors.white};
      text-decoration: none;
   }
`;

export default LinkIcon;
